<template>
  <section class="views">
    <!-- header -->
    <headers @viewUploadVideo="datumZZC = true"></headers>
    <!-- banner  -->
    <div class="posters">
      <van-image
        width="100%"
        :src="
          require(`@/assets/image/hodgepodge/pcbanner_${this.$i18n.locale}.jpg`)
        "
      />
      <!-- <div class="posters_ewm">
        <div class="ewm" @click="whatapp()">
          <div class="ewm2">
            <div class="ewm3">
              <img :src="require('@/assets/image/hodgepodge/ewm.png')" alt="" />
            </div>
            <div class="ewm3_value">
              <img :src="require('@/assets/image/wa.png')" alt="" /> 人工咨询
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <!-- 举办方 -->
    <div class="organizers">
      <div class="box_uls">
        <div class="box_title">
          <img
            :src="require('@/assets/image/homeTitle/title_img.png')"
            alt=""
          />
          <div class="title">
            {{ $t("home.organizing_and_supporting_agencies.title") }}
          </div>
        </div>
        <div class="box_centent zhuban">
          <div class="xiaoIconBox">
            <!-- <div class="xiaoIconList" style="display: flex;align-items: center;justify-content: center;">
              <img style="width:85%;height:85%;" :src="require('@/assets/image/hodgepodge/logo_0.jpg')" alt="" />
            </div> -->
            <div class="xiaoIconList">
              <img
                :src="require('@/assets/image/hodgepodge/logo_1.png')"
                alt=""
              />
            </div>
            <div class="xiaoIconList">
              <img :src="require('@/assets/image/xiao/xiao4.png')" alt="" />
            </div>
          </div>
          <div class="xiaoIconBox" style="margin-bottom: 30px">
            <div class="xiaoIconList" style="padding:4px;">
              <img
                :src="require('@/assets/image/hodgepodge/logo_2.png')"
                alt=""
              />
            </div>
            <div class="xiaoIconList" style="padding:4px;">
              <img
                :src="require('@/assets/image/hodgepodge/logo_3.png')"
                alt=""
              />
            </div>
            <div class="xiaoIconList" style="padding:5px;">
              <img
                :src="require('@/assets/image/hodgepodge/logo_4.jpg')"
                alt=""
              />
            </div>
            <!-- <div class="xiaoIconList">
              <img
                :src="require('@/assets/image/hodgepodge/logo_5.png')"
                alt=""
              />
            </div>
            <div class="xiaoIconList" style="padding:5px;">
              <img
                :src="require('@/assets/image/hodgepodge/logo_6.jpg')"
                alt=""
              />
            </div>
            <div class="xiaoIconList" style="padding:5px;">
              <img :src="require('@/assets/image/hodgepodge/logo_7.png')" alt="" />
            </div> -->
          </div>

          <div class="posters_text">
            <ul>
              <!-- <li>
                <div class="posters_text_left">
                  {{
                    $t(
                      "home.organizing_and_supporting_agencies.Sponsoring_agency"
                    )
                  }}：
                </div>
                <div class="posters_text_right">
                  {{
                    $t(
                      "home.organizing_and_supporting_agencies.Sponsoring_agency_text"
                    )
                  }}
                </div>
              </li> -->
              <li>
                <div class="posters_text_left">
                  {{
                    $t(
                      "home.organizing_and_supporting_agencies.organizing_agency"
                    )
                  }}：
                </div>
                <div class="posters_text_right">
                  {{
                    $t(
                      "home.organizing_and_supporting_agencies.organizing_agency_text"
                    )
                  }}
                </div>
              </li>
              <li>
                <div class="posters_text_left">
                  {{
                    $t(
                      "home.organizing_and_supporting_agencies.co_organizing_agency"
                    )
                  }}：
                </div>
                <div class="posters_text_right">
                  {{
                    $t(
                      "home.organizing_and_supporting_agencies.co_organizing_agency_text"
                    )
                  }}
                </div>
              </li>
              <li>
                <div class="posters_text_left">
                  {{
                    $t(
                      "home.organizing_and_supporting_agencies.undertaking_agency"
                    )
                  }}：
                </div>
                <div class="posters_text_right">
                  {{
                    $t(
                      "home.organizing_and_supporting_agencies.undertaking_agency_text"
                    )
                  }}
                </div>
              </li>
              <!-- <li>
                <div class="posters_text_left">
                  {{
                    $t(
                      "home.organizing_and_supporting_agencies.supporting_agency"
                    )
                  }}：<br />
                  <span
                    style="font-size: 13px;font-weight: 400;line-height: 14px;"
                  >
                    {{
                      $t(
                        "home.organizing_and_supporting_agencies.supporting_agency_2"
                      )
                    }}
                  </span>
                </div>
                <div class="posters_text_right">
                  {{
                    $t(
                      "home.organizing_and_supporting_agencies.supporting_agency_text"
                    )
                  }}
                </div>
              </li> -->
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- 時間軸 -->
    <!-- <div class="TimeAxis">
      <ul>
        <div class="time_xian_top">
          <li
            v-for="(item, index) in tap"
            :key="index"
            @click="stageBut(index)"
          >
            <div
              :class="item.select ? 'select' : 'cshhSelect'"
              v-if="!item.select"
            >
              {{ item.name }}
            </div>
            <img
              :src="require('@/assets/image/qp/' + (index + 1) + '.png')"
              alt=""
              v-else
            />
          </li>
        </div>
      </ul>
      <ul>
        <div class="time_xian">
          <li
            v-for="(item, index) in tap"
            :key="index"
            @click="stageBut(index)"
          >
            <div class="xian">
              <span
                v-if="item.xuanSelect"
                :class="item.xuanSelect ? 'select' : ''"
                >{{ item.xuanSelect ? "當前階段" : "" }}</span
              >

              <span v-else :class="item.select ? 'span_t' : ''"></span>
            </div>
          </li>
        </div>
      </ul>
      <ul>
        <div class="time_xian_timeBox">
          <li
            v-for="(item, index) in tap"
            :key="index"
            v-html="item.tiem"
            @click="stageBut(index)"
          ></li>
        </div>
      </ul>
      <ul>
        <div class="time_xian_fuchuang">
          <li v-for="(item, index) in tap" :key="index">
            <template v-if="item.select">
              <div class="list">
                <h1>{{ item.content.title }}</h1>
                <div class="p_xian" v-html="item.content.value"></div>
                <div
                  class="butom"
                  v-if="item.xuanSelect && index == 0"
                  @click="aheftBut()"
                >
                  <div class="buttomBut">在線報名</div>
                </div>
              </div>
            </template>
          </li>
        </div>
      </ul>
    </div> -->

    <!-- 比赛内容及赛程时间表 -->
    <div class="viewBoxContent">
      <div class="box_uls">
        <div class="box_title">
          <img
            :src="require('@/assets/image/homeTitle/title_img.png')"
            alt=""
          />
          <div class="title">
            {{ $t("home.competition_content_and_schedule.title") }}
          </div>
        </div>
        <div class="box_centent bxxq">
          <div class="contest_content">
            {{
              $t("home.competition_content_and_schedule.competition_content")
            }}
          </div>
          <div class="bxxq_title">
            {{ $t("home.competition_content_and_schedule.registration") }}
          </div>
          <div class="bxxq_centent">
            <div class="bag_text">
              {{
                $t("home.competition_content_and_schedule.registration_period")
              }}
            </div>
          </div>
          <div class="bxxq_title">
            {{ $t("home.competition_content_and_schedule.preliminary_round") }}
          </div>
          <div class="bxxq_centent">
            <div class="bag_text">
              <div style="margin-bottom: 5px">
                {{
                  $t("home.competition_content_and_schedule.preliminary_period")
                }}
              </div>
              <div v-html="$t('home.competition_content_and_schedule.preliminary_round_text1')"></div>
              <div v-html="$t('home.competition_content_and_schedule.preliminary_round_text2')"></div>
              <div v-html="$t('home.competition_content_and_schedule.preliminary_round_text3')"></div>
            </div>
            <ul>
              <li>
                {{
                  $t(
                    "home.competition_content_and_schedule.preliminary_review"
                  )
                }}：{{
                  $t(
                    "home.competition_content_and_schedule.preliminary_review_period"
                  )
                }}
              </li>
              <li>
                {{
                  $t(
                    "home.competition_content_and_schedule.announce_semifinalists"
                  )
                }}：{{
                  $t(
                    "home.competition_content_and_schedule.announce_semifinalists_date"
                  )
                }}
              </li>
            </ul>
          </div>
          <div class="bxxq_title">
            {{ $t("home.competition_content_and_schedule.semifinal") }}
          </div>
          <div class="bxxq_centent">
            <div class="bag_text">
              <div v-html="$t('home.competition_content_and_schedule.semifinal_period')"></div>
              <div v-html="$t('home.competition_content_and_schedule.semifinal_instructions')"></div>
            </div>
            <ul>
              <li>
                {{
                  $t("home.competition_content_and_schedule.semifinal_review")
                }}：{{
                  $t(
                    "home.competition_content_and_schedule.semifinal_review_period"
                  )
                }}
              </li>
              <li>
                {{
                  $t(
                    "home.competition_content_and_schedule.announce_finalists"
                  )
                }}：{{
                  $t(
                    "home.competition_content_and_schedule.announce_finalists_date"
                  )
                }}
              </li>
            </ul>
          </div>
          <div class="bxxq_title">
            {{
              $t(
                "home.competition_content_and_schedule.final_and_award_ceremony"
              )
            }}
          </div>
          <div class="bxxq_centent" style="margin-bottom: 12px">
            <div class="bag_text">
              <div style="margin-bottom: 5px">
                {{
                  $t(
                    "home.competition_content_and_schedule.final_and_award_ceremony_date"
                  )
                }}
              </div>
              <div>
                {{
                  $t("home.competition_content_and_schedule.final_instructions")
                }}
              </div>
            </div>
            <ul>
              <li v-html="$t('home.competition_content_and_schedule.competition_items')"></li>
              <li>
                {{
                  $t(
                    "home.competition_content_and_schedule.final_social_media_voting"
                  )
                }}<span>{{
                  $t(
                    "home.competition_content_and_schedule.final_social_media_voting_date"
                  )
                }}</span>
              </li>
              <li>
                {{
                  $t(
                    "home.competition_content_and_schedule.final_on_site_recitation_1"
                  )
                }}<span>{{
                  $t(
                    "home.competition_content_and_schedule.final_on_site_recitation_2"
                  )
                }}</span
                >{{
                  $t(
                    "home.competition_content_and_schedule.final_on_site_recitation_3"
                  )
                }}
              </li>

              <li>
                {{
                  $t("home.competition_content_and_schedule.final_time_limit")
                }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- 比赛安排 -->
    <div class="viewBoxContent">
      <div class="box_uls">
        <div class="box_title">
          <img
            :src="require('@/assets/image/homeTitle/title_img.png')"
            alt=""
          />
          <div class="title">{{ $t("home.Match_schedule.title") }}</div>
        </div>
        <div class="box_centent cszg">
          <div class="cszglis">
            <div class="cszg_title">
              {{ $t("home.Match_schedule.competition_groups.title") }}
            </div>
            <div class="cszg2_uls">
              <div class="cszg2_uls_list bz_color2">
                {{
                  $t(
                    "home.Match_schedule.competition_groups.group_a_description"
                  )
                }}
                <div class="select_bz">
                  {{ $t("home.Match_schedule.competition_groups.group_a") }}
                </div>
              </div>
              <div class="cszg2_uls_list bz_color">
                {{
                  $t(
                    "home.Match_schedule.competition_groups.group_b_description"
                  )
                }}
                <div class="select_bz">
                  {{ $t("home.Match_schedule.competition_groups.group_b") }}
                </div>
              </div>
              <div class="cszg2_uls_list bz_color2">
                {{
                  $t(
                    "home.Match_schedule.competition_groups.group_c_description"
                  )
                }}
                <div class="select_bz">
                  {{ $t("home.Match_schedule.competition_groups.group_c") }}
                </div>
              </div>
            </div>
            <div class="cszg_centent">
              <span>{{ $t("home.participant_requirements.note") }}</span
              >{{ $t("home.participant_requirements.additional_notes") }}
            </div>
            <div class="cszg_title">
              {{ $t("home.registration_competition.title_1") }}
            </div>
            <div class="cszg_centent">
              {{ $t("home.registration_competition.instruction_1") }}
            </div>
            <div class="bxxq_centent">
              <div class="a_view" @click="aheftBut">{{ $t("home.registration_competition.button") }}</div>
              <!-- <div class="a_view" @click="handleUploadVideo()">
                {{ $t("achievement.upload_video") }}
              </div> -->
              <!-- <div class="a_view" style="color: #999;">{{ $t('achievement.has_ended') }}</div>  -->
            </div>

            <div class="cszg_title">
              {{ $t("home.competition_rules.title") }}
            </div>
            <div class="cszg_centent">
              {{ $t("home.competition_rules.instruction") }}
            </div>
            <div class="bxxq_centent">
              <div class="a_view" @click="zhangcheng()">
                {{ $t("home.competition_rules.button") }}
              </div>
            </div>

            <div class="cszg_title">
              {{ $t("home.competition_materials.title") }}
            </div>
            <div class="bxxq_centent">
              <div class="font_red" style="margin-bottom: 10px; text-align: left;">{{ $t("home.competition_materials.group_1") }}</div>
              <ul>
                <li>{{ $t("home.competition_materials.instruction_1") }}</li>
                <li>{{ $t("home.competition_materials.instruction_2") }}</li>
                <li>{{ $t("home.competition_materials.instruction_3") }}</li>
              </ul>
              <div class="a_view" @click="socai('https://chineserd-audio-1256597606.cos.accelerate.myqcloud.com/readingcontest/id/eda8e3ffd8ce10b372bb49ddd52291fd.pdf')" style="margin-top: 24px">
                {{ $t("home.competition_materials.button") }}
              </div>
            </div>
            <div class="bxxq_centent">
              <div class="font_red" style="margin-bottom: 10px;text-align: left;">{{ $t("home.competition_materials.group_2") }}</div>
              <ul>
                <li>{{ $t("home.competition_materials.instruction_1") }}</li>
                <li>{{ $t("home.competition_materials.instruction_2") }}</li>
                <li>{{ $t("home.competition_materials.instruction_3") }}</li>
              </ul>
              <div class="a_view" @click="socai('https://chineserd-audio-1256597606.cos.accelerate.myqcloud.com/readingcontest/id/b85819ebd229ed3fd3f45034e2db6a9e.pdf')" style="margin-top: 24px">
                {{ $t("home.competition_materials.button") }}
              </div>
            </div>
            <div class="bxxq_centent">
              <div class="font_red" style="margin-bottom: 10px;text-align: left;">{{ $t("home.competition_materials.group_3") }}</div>
              <ul>
                <li>{{ $t("home.competition_materials.instruction_4") }}</li>
                <li>{{ $t("home.competition_materials.instruction_5") }}</li>
                <li>{{ $t("home.competition_materials.instruction_3") }}</li>
              </ul>
              <div class="a_view" @click="socai('https://chineserd-audio-1256597606.cos.accelerate.myqcloud.com/readingcontest/id/d3b14003c8f5baa385e7bac9cfc8afed.pdf')" style="margin-top: 24px">
                {{ $t("home.competition_materials.button") }}
              </div>
            </div>
            <div class="cszg_title">
              {{ $t("home.scoring_criteria.title") }}
            </div>
            <div class="bxxq_centent">
              <div
                class="a_view"
                @click="onScoringStandard()"
                style="margin-top: 44px"
              >
                {{ $t("other_pages.view_scoring_standard") }}
              </div>
            </div>
            <div class="cszg_centent">
              *{{ $t("home.scoring_criteria.instruction") }}
            </div>
            <div class="bxxq_centent"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 參賽奬項  -->
    <div class="viewBoxContent" style="margin-bottom: 20px">
      <div class="box_uls">
        <div class="box_title">
          <img
            :src="require('@/assets/image/homeTitle/title_img.png')"
            alt=""
          />
          <div class="title">
            {{ $t("home.competition_phases.competition_award") }}
          </div>
        </div>
        <div class="tables">
          <table>
            <thead>
              <tr>
                <th style="width: 18%">
                  <strong>{{ $t("home.competition_phases.title") }}</strong>
                </th>
                <th style="width: 18%">
                  <strong>{{ $t("home.competition_phases.awards") }}</strong>
                </th>
                <th>
                  <strong>{{ $t("home.competition_phases.prizes") }}</strong>
                </th>
                <th style="width: 30%">
                  <strong>{{
                    $t("home.competition_phases.selection_method")
                  }}</strong>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <strong>{{
                    $t("home.competition_phases.preliminary_phase")
                  }}</strong>
                </td>
                <td>
                  <strong>{{
                    $t("home.competition_phases.participation_certificate")
                  }}</strong>
                </td>
                <td>
                  <strong>{{
                    $t(
                      "home.competition_phases.electronic_participation_certificate"
                    )
                  }}</strong>
                </td>
                <td>
                  <strong>{{
                    $t("home.competition_phases.submit_recitation_audio")
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td>
                  <strong>{{
                    $t("home.competition_phases.semifinal_phase")
                  }}</strong>
                </td>
                <td>
                  <strong>{{
                    $t("home.competition_phases.semifinal_certificate")
                  }}</strong>
                </td>
                <td>
                  <strong>{{
                    $t(
                      "home.competition_phases.electronic_semifinal_certificate"
                    )
                  }}</strong>
                </td>
                <td>
                  <strong>{{
                    $t("home.competition_phases.top_100_per_group")
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td rowspan="6">
                  <strong>{{
                    $t("home.competition_phases.final_phase")
                  }}</strong>
                </td>
                <td>
                  <strong>{{
                    $t("home.competition_phases.first_prize")
                  }}</strong>
                </td>
                <td style="text-align: left">
                  {{ $t("home.competition_phases.first_prize_amount_1") }}<br />
                  {{ $t("home.competition_phases.first_prize_amount_2") }}<br />
                  {{ $t("home.competition_phases.first_prize_amount_3") }}<br />
                  <!-- <span>{{
                    $t("home.competition_phases.first_prize_amount_3_1")
                  }}</span
                  >{{ $t("home.competition_phases.first_prize_amount_3_1_text")
                  }}<br /> -->
                  <span>{{
                    $t("home.competition_phases.first_prize_amount_3_2")
                  }}</span
                  >{{ $t("home.competition_phases.first_prize_amount_3_2_text")
                  }}<br />
                  <span>{{
                    $t("home.competition_phases.first_prize_amount_3_3")
                  }}</span
                  >{{
                    $t("home.competition_phases.first_prize_amount_3_3_text")
                  }}
                </td>

                <td rowspan="6">
                  <strong>{{
                    $t("home.competition_phases.on_site_competition")
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td>
                  <strong>{{
                    $t("home.competition_phases.second_prize")
                  }}</strong>
                </td>
                <td style="text-align: left">
                  {{ $t("home.competition_phases.second_prize_amount_1")
                  }}<br />
                  {{ $t("home.competition_phases.second_prize_amount_2")
                  }}<br />
                  {{ $t("home.competition_phases.second_prize_amount_3")
                  }}<br />
                  <!-- <span>{{
                    $t("home.competition_phases.second_prize_amount_3_1")
                  }}</span
                  >{{
                    $t("home.competition_phases.second_prize_amount_3_1_text")
                  }}<br /> -->
                  <span>{{
                    $t("home.competition_phases.second_prize_amount_3_2")
                  }}</span
                  >{{
                    $t("home.competition_phases.second_prize_amount_3_2_text")
                  }}<br />
                  <span>{{
                    $t("home.competition_phases.second_prize_amount_3_3")
                  }}</span
                  >{{
                    $t("home.competition_phases.second_prize_amount_3_3_text")
                  }}
                </td>
              </tr>
              <tr>
                <td>
                  <strong>{{
                    $t("home.competition_phases.third_prize")
                  }}</strong>
                </td>
                <td style="text-align: left">
                  {{ $t("home.competition_phases.third_prize_amount_1") }}<br />
                  {{ $t("home.competition_phases.third_prize_amount_2") }}<br />
                  {{ $t("home.competition_phases.third_prize_amount_3") }}<br />
                  <!-- <span>{{
                    $t("home.competition_phases.third_prize_amount_3_1")
                  }}</span
                  >{{ $t("home.competition_phases.third_prize_amount_3_1_text")
                  }}<br /> -->
                  <span>{{
                    $t("home.competition_phases.third_prize_amount_3_2")
                  }}</span
                  >{{ $t("home.competition_phases.third_prize_amount_3_2_text")
                  }}<br />
                  <span>{{
                    $t("home.competition_phases.third_prize_amount_3_3")
                  }}</span
                  >{{
                    $t("home.competition_phases.third_prize_amount_3_3_text")
                  }}
                </td>
              </tr>
              <tr>
                <td>
                  <strong>{{
                    $t("home.competition_phases.most_popular_award")
                  }}</strong>
                </td>
                <td style="text-align: left">
                  {{ $t("home.competition_phases.most_popular_award_amount_1")
                  }}<br />
                  {{
                    $t("home.competition_phases.most_popular_award_amount_2")
                  }}
                </td>
              </tr>
              <tr>
                <td>
                  <strong>{{
                    $t("home.competition_phases.creative_award")
                  }}</strong>
                </td>
                <td style="text-align: left">
                  {{ $t("home.competition_phases.creative_award_amount_1")
                  }}<br />
                  {{ $t("home.competition_phases.creative_award_amount_2") }}
                </td>
              </tr>
              <tr>
                <td>
                  <strong>{{
                    $t("home.competition_phases.encouragement_award")
                  }}</strong>
                </td>
                <td style="text-align: left">
                  {{ $t("home.competition_phases.encouragement_award_amount_1")
                  }}<br />
                  {{
                    $t("home.competition_phases.encouragement_award_amount_2")
                  }}
                </td>
              </tr>
            </tbody>
          </table>
          <div
            style="
              margin-top: 20px;
              line-height: 25px;
              text-align: left;
              font-size: 16px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #e80202;
            "
          >
            *{{ $t("home.competition_phases.final_disclaimer") }}
          </div>
        </div>
      </div>
    </div>
    <!-- 佔位 -->
    <!-- <div class="viewBoxContent"></div> -->
    <!-- <div class="uploadVideo" @click="handleUploadVideo()">上載影片</div> -->
    <!-- 复赛资料视频上传-->
    <van-popup
      style="margin-top: 30px"
      v-model="datumZZC"
      :close-on-click-overlay="false"
      :closeable="true"
      :round="true"
      :lock-scroll="false"
    >
      <div class="datumBox">
        <div class="titleH1">
          <div class="left_icon">
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div class="title">{{ $t("achievement.upload_video_text") }}</div>
          <div class="right_icon">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>

        <div class="stepBox">
          <div class="stepUls">
            <div
              class="xian"
              :class="stepActive > 0 ? 'active2' : 'active'"
            ></div>
            <div
              class="xian"
              :class="stepActive >= 2 ? 'active2' : 'active'"
            ></div>
          </div>

          <ul>
            <li
              v-for="(item, index) in 3"
              :class="stepActive >= index ? 'active' : ''"
              :key="index"
            ></li>
          </ul>
        </div>
        <div class="stepText">
          <div :class="stepActive >= 0 ? 'active' : ''">
            {{ $t("achievement.login") }}
          </div>
          <div :class="stepActive >= 1 ? 'active' : ''">
            {{ $t("achievement.improve_info") }}
          </div>
          <div :class="stepActive >= 2 ? 'active' : ''">
            {{ $t("achievement.upload_video") }}
          </div>
        </div>

        <div class="datumCentent" v-if="stepActive == 0">
          <div class="tab">
            <div class="promptInput">
              <CountryCodeSelector
                :searchbar="false"
                :countryCode.sync="prefix"
                style="width: 80px; margin-right: 15px"
              ></CountryCodeSelector>
              <input
                type="text"
                :placeholder="$t('achievement.enter_tel_join')"
                value=""
                v-model.trim="from.phone"
              />
            </div>
            <div class="promptInput">
              <input
                :placeholder="$t('achievement.enter_name')"
                v-model="from.name"
              />
            </div>
          </div>
          <div class="tabTis">
            {{ $t("achievement.submit_tips") }}
            <a href="http://wa.me/6281334941415" target="_blank" @click="lianxi"
              ><img src="@/assets/image/fusai/whatsapp.png"
            /></a>
          </div>
          <div
            class="but"
            style="cursor: pointer"
            @click="datumActiveBut ? datumBut(0) : ''"
          >
            {{ $t("achievement.next_step") }}
          </div>
        </div>

        <div class="datumCentent" v-if="stepActive == 1">
          <div class="tab">
            <div class="prompt">
              {{  $t('achievement.certificate_upload') }}
              <span>&nbsp;{{  $t('achievement.upload_certificate_text') }}</span>
            </div>
            <div class="promptInput3" style="margin: 10px 0 15px;">
              <uploaderCent
                @uploaderChange="uploaderImageChange"
                accept="image/*"
                :uploadText="$t('achievement.click_upload')"
                logoaAtive="0"
              ></uploaderCent>
            </div>

            <div class="cell-item">
              <div class="promptInput">
                <input
                  :placeholder="$t('achievement.enter_birthday')"
                  :value="from.birthday"
                  readonly
                />
                <span class="right-btn" @click="showDatePicker = true">{{ $t('achievement.enter_birthday') }}</span>
              </div>
              <div class="tips">{{ $t('achievement.enter_birthday_tips') }}</div>
            </div>
            <div class="cell-item">
              <div class="promptInput">
                <input
                  v-model="from.birthplace"
                  :placeholder="$t('achievement.enter_birthplace')"
                />
              </div>
              <div class="tips">{{ $t('achievement.enter_birthplace_tips') }}</div>
            </div>
            <div class="cell-item">
              <div class="promptInput">
                <input
                  :placeholder="$t('achievement.enter_instructor')"
                  v-model="from.instructor"
                />
              </div>
              <div class="tips">{{ $t('achievement.enter_instructor_tips') }}</div>
            </div>
          </div>

          <div class="tabTis">
            {{ $t('achievement.submit_tips') }}
            <a href="http://wa.me/6281334941415" target="_blank" @click="lianxi"
              ><img src="@/assets/image/fusai/whatsapp.png"
            /></a>
          </div>
          <div class="but" style="cursor: pointer" @click="datumBut(1)">
            {{ $t("achievement.next_step") }}
          </div>
          <!-- <div class="but2" style="cursor: pointer;" @click="getBack()">
            {{ $t("achievement.prev_step") }}
          </div> -->
        </div>

        <div class="datumCentent" v-if="stepActive == 2">
          <div class="tab">
            <div class="promptInput3">
              <uploaderCent
                @uploaderChange="uploaderVideoChange"
                accept="video/*"
                :uploadText="$t('achievement.click_upload_video')"
                v-if="wonderful == false"
                logoaAtive="1"
              ></uploaderCent>
              <!-- 上傳影片成功后顯示預覽按鈕 -->
              <div class="videoYulan" v-if="videoYL">
                <div class="guanbu" style="cursor: pointer" @click="videoYLBut">
                  X
                </div>
                <video controls :autoplay="true" :src="videoUrl"></video>
              </div>
              <div
                class="videoYulan2"
                style="cursor: pointer"
                v-if="from.video != null && wonderful == false"
                @click="videoYLBut"
              >
                <span style="color: #000000 !important; margin-right: 10px"
                  >{{ $t('achievement.upload_video_success') }}</span
                >{{ $t('achievement.click_view_video') }}
              </div>
              <!-- 點擊預覽視頻  @click="videoYLBut"-->
              <!-- <div class="viewVideo" v-if="from.video && wonderful == false">
                <div>影片已成功上載</div>
                <div
                  class="videoYulan2"
                  @click="videoYLBut"
                >
                  點擊預覽視頻
                </div>
              </div>
              <div v-if="from.video && wonderful == false" class="reselect">重新选择</div> -->

              <!-- 提交成功 -->
              <div class="wonderful" v-if="wonderful == true">
                <img src="@/assets/image/fusai/ludui.png" />
                {{ $t('achievement.been_success_wait')}}
              </div>
            </div>
          </div>
          <div class="tabTis" v-if="wonderful == false">
            {{ $t('achievement.submit_tips') }}
            <a href="http://wa.me/6281334941415" target="_blank" @click="lianxi"
              ><img src="@/assets/image/fusai/whatsapp.png"
            /></a>
          </div>
          <div
            class="but"
            style="cursor: pointer"
            v-if="wonderful == false"
            @click="datumActiveBut ? submit() : ''"
          >
          {{ $t('achievement.submit')}}
          </div>
          <!-- <div class="but2" style="cursor: pointer;" @click="getBack()">
            返回上一步
          </div> -->
          <div
            class="but"
            style="cursor: pointer"
            v-if="wonderful == true"
            @click="wonderfulBut"
          >
          {{ $t('achievement.ok')}}
            
          </div>
        </div>

        <!-- 未入圍/成功入園 -->
        <van-popup v-model="newShortZZC" :round="true" :lock-scroll="false">
          <div class="newShortBox">
            <div class="list" v-if="newShortActive == 2">
              <div class="ulst">
                <ul>
                  <li>{{ $t("achievement.name") }}</li>
                  <li>{{ $t("achievement.group") }}</li>
                  <li>{{ $t("achievement.score") }}</li>
                </ul>
                <ul>
                  <li>
                    {{ userObj.studentName == null ? "" : userObj.studentName }}
                  </li>
                  <li>
                    {{
                      userObj.competitionGroup == null
                        ? ""
                        : userObj.competitionGroup
                    }}
                  </li>
                  <li>{{ userObj.score == null ? "" : userObj.score }}</li>
                </ul>
              </div>
              <div class="lis lisText" v-html="$t('achievement.join_fail')"></div>
            </div>
          </div>
        </van-popup>
      </div>
    </van-popup>
    <van-dialog
      v-model="showGuide"
      :show-close-button="false"
      :close-on-click-overlay="true"
      width="80%"
      z-index="99999"
      :confirm-button-text="$t('other_pages.close')"
      @close="closeDialog"
    >
      <div class="guide-container" v-if="showType == 'img'">
        <van-image
          width="100%"
          :src="require('@/assets/image/PC_guide.jpg')"
          fit="contain"
        />
      </div>
      <div class="guide-container" v-if="showType == 'video'">
        <video
          height="99%"
          controls
          :autoplay="true"
          src="https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/dev/2024-04/1d48744a1c3f5f6dfb8f0a95c4bc66cd.mp4"
        ></video>
      </div>
    </van-dialog>

    <van-dialog v-model="showDatePicker"
      :title="$t('achievement.enter_birthday')"
      :confirmButtonText="$t('other_pages.confirm')"
      @confirm="confirmDate"
    >
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        :min-date="minDate"
        :max-date="maxDate"
        :show-toolbar="false"
        @cancel="showDatePicker = false"
      />
    </van-dialog>
  </section>
</template>

<script>
import headers from "@/components/header/pc_header";
import publics from "@/mixin/public_mixin";
import home from "@/mixin/home_mixin";
import uploaderCent from "@/components/uploaderBox/index.vue";
import CountryCodeSelector from "@/components/CountryCodeSelector";
export default {
  name: "views",
  data() {
    return {
      // select:true,    選擇
      // xuanSelect:true, 階段
      ermUrl: sessionStorage.getItem("whatAppEwm"),
      tap: [
        {
          name: "正式報名",
          tiem: `4月16日<br/> 至 <br/>5月21日 22:00`,
          select: true,
          xuanSelect: true,
          content: {
            title: "正式報名",
            value: "官方活動網站或中文路APP：ChineseRd Plus",
          },
        },
        {
          name: "初賽",
          tiem: `4月16日<br/> 至 <br/>5月21日 23:59`,
          select: false,
          xuanSelect: false,
          content: {
            title: "中文路APP",
            value: `通過中文路App進行普通話語音測試，每人共有5次測試機會，將自動選擇最高分的1次參與評選，各組別分數排名最多<span style="color:red;">前100名</span>將獲得入圍複賽資格，參與複賽影片錄製。`,
          },
        },
        {
          name: "公佈複賽入圍名單",
          tiem: `5月22日`,
          select: false,
          xuanSelect: false,
          content: {
            title: "官方活動網站公佈名單或登入中文路App查詢個人入圍情況",
            value: "請留意電郵或短信提醒並查閱入圍結果。",
          },
        },
        {
          name: "複賽",
          tiem: `5月22日<br/> 至 <br/>6月6日 23:59`,
          select: false,
          xuanSelect: false,
          content: {
            title: "官方活動網站或中文路APP",
            value: `
            複賽入圍學生須使用當前組別官方指定誦材，並進行影片錄製，可通過官方活動網站或中文路App提交複賽影片，複賽各組別分數排名<span style="color:red;">前10名</span>將獲得進入決賽資格。`,
          },
        },
        {
          name: "公佈決賽入圍名單",
          tiem: `6月15日`,
          select: false,
          xuanSelect: false,
          content: {
            title: "官方活動網站公佈名單",
            value: "請留意電郵或短信提醒並查閱入圍結果。",
          },
        },
        {
          name: "決賽暨頒獎典禮",
          tiem: `6月29日`,
          select: false,
          xuanSelect: false,
          content: {
            title: "（請留意主辦方最新公佈的安排為準）",
            value: "將於線下場所進行現場對決比賽，上半場決賽，下半場頒獎典禮。",
          },
        },
      ],
      select: 3,
      datumZZC: false, // 上传视频弹窗控制
      stepActive: 0, //控制流程  很重要这玩意勿搞错  参数0 1 2  表示三步骤
      datumActiveBut: true, //防止連續點擊
      wonderful: false, //成功
      videoYL: false, //預覽
      from: {
        name: null, //名字
        phone: null, //手机
        certificate: null, //证件
        birthday: null, //生日
        birthplace: null, //生日
        instructor: null, //生日
        video: null, //视频
      },
      newShortZZC: false, //入圍 彈窗
      newShortActive: 1, //1是成功  2是失敗
      choose: 0, //查詢的下標
      finalistsBut: true, //防止連續點擊
      userObj: {
        competitionGroup: null, //組別
        score: null, //分數
        studentName: null, //名字
      },
      prefix: 62,
      showGuide: false,
      showType: "",
      showDatePicker: false,
      minDate: new Date(1970, 0, 1),
      maxDate: new Date(),
      currentDate: new Date()

    };
  },
  computed: {},
  components: {
    headers,
    uploaderCent,
    CountryCodeSelector,
  },
  mixins: [publics, home],
  watch: {},
  created() {},
  mounted() {
    if (this.$route.query.uploadVideo === 'true') {
      this.datumZZC = true;
      this.$router.replace({ query: { uploadVideo: false } });
    }
  },
  methods: {
    uploaderImageChange(e) {
      this.from.certificate = e.vaidoUrl
      this.$toast.clear()
    },
    confirmDate() {
      this.from.birthday = this.formatDate(this.currentDate)
    },
    formatDate(date) {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = `0${d.getMonth() + 1}`.slice(-2);
      const day = `0${d.getDate()}`.slice(-2);
      return `${year}-${month}-${day}`;
    },
    closeDialog() {
      const videoElement = document.querySelector(".guide-container video");
      // 暂停视频播放
      videoElement.pause();
    },
    handleShowGuide(type) {
      this.showGuide = true;
      this.showType = type;
      this.$nextTick(() => {
        // 动态浏览器视口高度
        const viewportHeight = window.innerHeight;
        const browserInterfaceHeight = window.outerHeight - window.innerHeight;
        const browserWindowHeight = viewportHeight - browserInterfaceHeight;
        const imageContainer = document.querySelector(".guide-container");
        imageContainer.style.height = `${browserWindowHeight}px`;
      });
    },
    handleUploadVideo() {
      // this.$dialog
      // .alert({
      //   title: '',
      //   message: this.$t('achievement.semi_ended'),
      //   confirmButtonText: this.$t('other_pages.confirm')
      // })
      // .then(() => {
      //   // on close
      // })
      // return;
      this.datumZZC = true;
    },
    whatapp() {
      this.home_mdevInit();
      window.open(this.whatUrl, "_blank");
    },
    aheftBut(e) {
      this.$router.push("/signup");
    },
    zhangcheng() {
      window.open(this.constitutionUrl, "_blank");
      // this.$router.push("/constitution");
      // this.$toast.loading({
      // 	message: '獲取地址中...',
      // 	forbidClick: true,
      // 	duration: 0
      // });

      // let url = 'https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/dev/2023-07/fe62588d996ef0818389f65f4192086c.pdf';
      // this.$axios({
      //   url: url,
      //   method: 'get',
      //   responseType: 'blob',
      // })
      // .then(response => {
      //   this.$toast.clear();
      //   this.$toast.success('開始下載');
      //   // 将文件流转化为 Blob 对象，并创建 a 标签进行下载
      //   const blob = new Blob([response.data], { type: 'application/pdf' });
      //   const downloadElement = document.createElement('a');
      //   const href = window.URL.createObjectURL(blob); // 创建下载链接
      //   downloadElement.href = href;
      //   downloadElement.download = 'zhangcheng.pdf'; // 文件名
      //   document.body.appendChild(downloadElement);
      //   downloadElement.click(); // 下载
      //   document.body.removeChild(downloadElement); // 下载完成后移除元素
      //   window.URL.revokeObjectURL(href); // 释放占用的内存空间
      // }).catch(error => {
      //   this.$toast.clear();
      //   console.error(error); // 处理异常情况
      // });
    },
    socai(url) {
      window.open(url, "_blank");
    },
    onScoringStandard() {
      window.open(this.scoringStandardUrl, "_blank");
    },
    stageBut(e) {
      // console.log(e);
      this.tap.forEach((item, index) => {
        // console.log(item, index);
        if (index == e) {
          item.select = true;
        } else {
          item.select = false;
        }
      });
    },
    lianxi() {
      // 联系我们
      // window.location.href = 'http://wa.me/6281334941415'
      window.open("http://wa.me/6281334941415");
    },
    // 點擊上傳下一步
    datumBut(e) {
      switch (e) {
        case 0:
          // {{ $t('achievement.next_step') }} 驗證信息
          this.getUser();
          break;
        case 1:
          if (!this.from.certificate) {
            this.$toast(this.$t('achievement.upload_certificate') + " !")
            return
          }

          if (!this.from.birthday) {
            this.$toast(this.$t('achievement.enter_birthday') + " !");
            return;
          }

          if (!this.from.birthplace) {
            this.$toast(this.$t('achievement.enter_birthplace') + " !");
            return;
          }

          this.stepActive = 2;
          break;
        case 2:
          // 提交啦
          break;
      }
    },
    // 驗證信息
    getUser() {
      let params = {
        studentName: this.from.name,
        prefix: this.prefix,
        phone: this.from.phone,
      };

      if (params.studentName == "" || params.studentName == null) {
        this.$toast(this.$t("achievement.enter_name") + " !");
        return;
      }
      // 手機
      if (params.phone == "" || params.phone == null) {
        this.$toast(this.$t("achievement.enter_tel_join") + " !");
        return;
      }

      if (!this.validator_phone(params.phone)) {
        this.$toast(this.$t("achievement.phone_format_err") + " !");
        return;
      }

      this.datumActiveBut = false;
      this.$toast.loading();
      this.$axios
        .post(this.$api.getPersonInfo, params)
        .then((response) => {
          this.datumActiveBut = true;
          this.$toast.clear();
          const { data, code, msg } = response.data;
          if (code == 500) {
            this.$toast.fail(msg);
            return;
          }
          const { competitionGroup, score, studentName, shortlisted } = data;
          if (code == 0) {
            this.userObj.competitionGroup = competitionGroup; //組別
            this.userObj.score = score; //分數
            this.userObj.studentName = studentName; //名字

            if (shortlisted) {
              this.stepActive = 1;
            } else {
              // 失敗
              // this.datumZZC = false; //复赛资料上传弹窗
              this.stepActive = 0; //控制流程  很重要这玩意勿搞错  参数0 1 2  表示三步骤
              this.newShortZZC = true; //入圍 彈窗
              this.newShortActive = 2; //1是成功  2是失敗
            }
          }
        })
        .catch((error) => {
          this.$toast.clear();
          this.datumActiveBut = true;
          //请求失败
          this.$toast.fail("error");
        });
    },
    validator_phone(val) {
      const phone = val.trim();
      return /^[0-9]*$/.test(phone);
    },
    // 視頻
    uploaderVideoChange(e) {
      this.from.video = e.vaidoUrl;
      this.videoUrl = e.vaidoUrl;
      this.$toast.clear();
    },
    // 視頻預覽
    videoYLBut() {
      this.videoYL = !this.videoYL;
    },
    //返回上一步
    getBack() {
      this.stepActive--;
      this.from.video = null;
      this.videoUrl = null;
    },
    // 提交
    submit() {
      const { phone, name, video, certificate, birthday, birthplace, instructor } = this.from;
      let params = {
        personalID: certificate,
        studentName: name, //学生名字
        phone,
        birthday,
        birthplace,
        instructor,
        // videoUrl: 'https://materialv3-1256597606.cos.ap-hongkong.myqc…/dev/2023-09/eb816d9e21e9f18fccea6c461ba2c3dc.mp4', //学生上传的视频内容
        videoUrl: video, //学生上传的视频内容
      };

      if (params.videoUrl == null || params.videoUrl == "") {
        this.$toast(this.$t("achievement.upload_video_tips") + " !");
        return;
      }

      this.datumActiveBut = false;
      this.$toast.loading({
        message: this.$t("achievement.subming"),
        duration: 0,
        forbidClick: true,
      });

      // 本地測試專用
      // this.$axios({
      // 	url: '/api/statistics/competition/update',
      // 	method: 'post',
      // 	data: params
      // })

      // 正式發包
      this.$axios
        .post(this.$api.update, params)
        .then((response) => {
          this.datumActiveBut = true;
          // console.log(response);
          if (response.data.code == 500) {
            this.$toast.fail(response.data.msg);
          }
          if (response.data.code == 0) {
            this.$toast.clear();
            this.wonderful = true;
          }
        })
        .catch((error) => {
          this.datumActiveBut = true;
          //请求失败
          this.$toast.fail("error");
          console.log(error);
        });
    },
    // 上傳成功  相當於初始化
    wonderfulBut() {
      this.wonderful = false;
      this.datumZZC = false;
      this.stepActive = 0;
      this.from = {
        name: null, //名字
        phone: null, //手机
        birthday: null, //生日
        birthplace: null, //生日
        instructor: null, //生日
        video: null, //视频
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.views {
  width: 100%;
  height: 100vh;
  overflow-x: hidden;
  background: #ff782f;
  .posters {
    width: 100%;
    display: flex;
    position: relative;

    img {
      width: 100%;
    }

    .posters_ewm {
      position: absolute;
      // width: 1024px;
      left: 0;
      right: 15%;
      bottom: 0;
      top: 0%;
      margin: auto;
      display: flex;
      align-items: flex-start;
      justify-content: right;

      .ewm {
        width: 141px;
        min-height: 184px;
        background: rgba(255, 255, 255, 0.63);
        border-radius: 16px 16px 16px 16px;
        padding: 6px;
        box-sizing: border-box;
        cursor: pointer;

        .ewm2 {
          width: 100%;
          height: 100%;
          background: #fdcf1d;
          border-radius: 12px 12px 12px 12px;
          box-sizing: border-box;
          padding-top: 4px;
          .ewm3 {
            margin: 0 auto;
            width: 122px;
            height: 122px;
            background: #ffffff;
            border-radius: 8px 8px 8px 8px;
            margin-bottom: 6px;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }

          .ewm3_value {
            width: 100%;
            height: 40px;
            font-size: 16px;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 600;
            color: #323232;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            background: url("~@/assets/image/icon/ewmbut.png") no-repeat;
            background-size: 100% 100%;
            box-shadow: inset 0px 1px 4px 0px rgba(234, 138, 7, 0.48),
              inset 0px -5px 3px 0px rgba(255, 227, 129, 0.57);
            vertical-align: middle; /* 将文本和图片垂直居中对齐 */

            img {
              width: 20px;
              height: 20px;
              margin-right: 4px;
              vertical-align: middle; /* 将图片和文本垂直居中对齐 */
            }
          }
        }
      }
    }
  }

  .organizers {
    max-width: 1240px;
    margin: auto;
    margin-bottom: 54px;
    margin-top: 30px;
    .box_uls {
      width: 964px;
      min-height: 100px;
      margin: auto;
      box-sizing: border-box;
      border-image-source: url("~@/assets/image/hodgepodge/pcbeij.png");
      border-image-slice: 84 10 10 10;
      border-image-width: 67px 9px 9px 9px;
      border-width: 9px;
      padding: 0 10px 10px 10px;
      box-sizing: border-box;

      .box_title {
        width: 100%;
        height: 25px;
        box-sizing: border-box;
        margin: auto;
        position: relative;
        img {
          // width: 100%;
          height: 118.8px;
          margin-top: -6.1%;
          // object-fit: none;
        }

        .title {
          position: absolute;
          top: -36px;
          left: 50%;
          transform: translateX(-50%);
          font-size: 30px;
          font-weight: bold;
          color: #fff;
          // text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
          text-shadow: -1px -1px 0 #ff782f, 1px -1px 0 #ff782f,
            -1px 1px 0 #ff782f, 1px 1px 0 #ff782f;
          width: 74%;
        }
      }
      .box_centent {
        position: relative;
        width: 100%;
        background: #fff;
        border-radius: 12px;
      }

      .zhuban {
        padding: 21px 100px 8px 130px;
        box-sizing: border-box;

        .xiaoIconBox {
          width: 100%;
          display: flex;
          justify-content: center;
          margin-bottom: 20px;

          .xiaoIconList {
            width: 153px;
            height: 64px;
            background: #ffffff;
            border-radius: 12px 12px 12px 12px;
            box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.03);
            margin: 0 15px;
            box-sizing: border-box;
            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
          // 最后一个不要右边距
          // .xiaoIconList:last-child {
          //   margin-right: 0;
          // }
        }

        .posters_text {
          width: 100%;

          ul {
            width: 100%;

            li {
              width: 100%;
              margin-bottom: 16px;
              display: flex;

              .posters_text_left {
                width: 130px;
                font-size: 14px;
                font-family: PingFang SC-Semibold, PingFang SC;
                font-weight: 600;
                color: #333333;
                line-height: 18px;
                text-align: left;
              }

              .posters_text_right {
                width: calc(100% - 130px);
                font-size: 14px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
                line-height: 18px;
                text-align: left;
              }
            }
          }
        }
      }
    }
  }

  .TimeAxis {
    max-width: 1240px;
    margin: auto;

    ul {
      width: 100%;

      .time_xian {
        width: 100%;
        background: linear-gradient(
          270deg,
          rgba(255, 255, 255, 0) 0%,
          #ffffff 22%,
          #ffffff 80%,
          rgba(255, 255, 255, 0) 100%
        );
        display: flex;
        justify-content: space-evenly;

        li {
          width: 167px;
          display: flex;
          align-items: center;

          .xian {
            width: 100%;
            height: 8px;
            display: flex;
            align-items: center;
            justify-content: center;

            span {
              width: 16px;
              height: 16px;
              background: #ffffff;
              border: 2px solid #ffffff;
              border-radius: 50px;
              cursor: pointer;
            }

            .span_t {
              width: 20px !important;
              height: 20px !important;
              background: #ffe600 !important;
            }

            .select {
              width: auto !important;
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 0 10px;
              font-size: 14px;
              text-align: center;
              box-sizing: border-box;
              background: #f78040;
              border-radius: 50px;
              border: 1px solid #fff;
              color: #fff;
            }
          }
        }
      }

      .time_xian_top {
        width: 100%;
        height: 86px;
        display: flex;
        justify-content: space-evenly;
        margin-bottom: 17px;

        li {
          width: 167px;
          display: flex;
          align-items: center;
          display: flex;
          justify-content: center;
          align-items: flex-end;
          cursor: pointer;
        }

        // .select {
        // border-image-source: url("~@/assets/image/icon/qipao.png");
        // border-image-slice: 84 10 10 10;
        // border-image-width: 33px 9px 0px 10px;
        // border-width: 9px;
        // padding: 7px 17px 14px 17px;
        // box-sizing: border-box;
        // font-size: 16px;
        // font-family: PingFang SC-Semibold, PingFang SC;
        // font-weight: 600;
        // color: #903300;
        // line-height: 16px;
        // }

        .cshhSelect {
          font-size: 16px;
          font-family: PingFang SC-Semibold, PingFang SC;
          // font-weight: 600;
          color: #ffffff;
          line-height: 19px;
        }

        img {
          width: 100%;
          object-fit: contain;
        }
      }

      .time_xian_timeBox {
        width: 100%;
        display: flex;
        justify-content: space-evenly;
        margin-top: 17px;

        li {
          width: 167px;
          display: flex;
          align-items: center;
          display: flex;
          justify-content: center;
          align-items: flex-start;
          font-size: 14px;
          font-family: PingFang SC-Semibold, PingFang SC;
          font-weight: 600;
          color: #ffffff;
          line-height: 22px;
          cursor: pointer;
        }
      }

      .time_xian_fuchuang {
        width: 100%;
        display: flex;
        justify-content: space-evenly;

        li {
          width: 167px;
          min-height: 136px;

          .list {
            width: 343px;
            min-height: 136px;
            box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.05);
            padding: 12px;
            box-sizing: border-box;
            margin-top: 38px;
            border-radius: 16px;
            background: #ffffff;
            position: relative;

            h1 {
              font-size: 16px;
              font-family: PingFang SC-Semibold, PingFang SC;
              font-weight: 600;
              color: #f97226;
              line-height: 20px;
              text-align: center;
              margin-bottom: 4px;
              text-align: left;
            }

            .p_xian {
              width: 100%;
              font-size: 14px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #666666;
              line-height: 22px;
              text-align: left;
            }

            .butom {
              width: 100%;
              display: flex;
              justify-content: right;
              position: absolute;
              bottom: 0;
              padding: 0 24px 12px 0;
              box-sizing: border-box;

              .buttomBut {
                padding: 10px 12px;
                box-sizing: border-box;
                border-radius: 16px;
                font-size: 12px;
                font-family: PingFang SC-Semibold, PingFang SC;
                font-weight: 600;
                color: #ffffff;
                line-height: 14px;
                background: url("~@/assets/image/hodgepodge/buttom.png")
                  no-repeat;
                background-size: 100% 100%;
                cursor: pointer;
              }
            }
          }
        }

        li:last-child {
          .list {
            float: right;
          }
        }
      }
    }
  }

  .viewBoxContent {
    max-width: 1240px;
    margin: auto;
    margin-top: 104px;

    .box_uls {
      width: 964px;
      min-height: 314px;
      margin: auto;
      box-sizing: border-box;
      border-image-source: url("~@/assets/image/hodgepodge/pcbeij.png");
      border-image-slice: 84 10 10 10;
      border-image-width: 67px 9px 9px 9px;
      border-width: 9px;
      padding: 0 10px 10px 10px;
      box-sizing: border-box;

      .box_title {
        width: 100%;
        height: 25px;
        box-sizing: border-box;
        margin: auto;
        position: relative;

        img {
          // width: 100%;
          height: 118.8px;
          margin-top: -6.1%;
          // object-fit: none;
        }
        .title {
          position: absolute;
          top: -36px;
          left: 50%;
          transform: translateX(-50%);
          font-size: 30px;
          font-weight: bold;
          color: #fff;
          // text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
          text-shadow: -1px -1px 0 #ff782f, 1px -1px 0 #ff782f,
            -1px 1px 0 #ff782f, 1px 1px 0 #ff782f;
          width: 70%;
        }
      }
      .box_centent {
        position: relative;
        width: 100%;
        background: #ffffff;
        border-radius: 12px;
        padding: 24px 130px;
        box-sizing: border-box;
      }

      .cszg {
        width: 100%;

        .cszglis {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          .cszg2_uls {
            width: 100%;
            padding-left: 12px;
            box-sizing: border-box;
            margin-bottom: 24px;

            .cszg2_uls_list {
              width: 100%;
              height: 48px;
              border-radius: 0px 0px 0px 0px;
              font-size: 15px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #666666;
              line-height: 15px;
              position: relative;
              display: flex;
              align-items: center;
              justify-content: center;

              .select_bz {
                min-width: 79px;
                background: #f97226;
                border-radius: 60px 60px 60px 60px;
                padding: 3px 18px;
                box-sizing: border-box;
                background: #f97226;
                border-radius: 60px 60px 60px 60px;
                font-size: 15px;
                font-family: PingFang SC-Semibold, PingFang SC;
                font-weight: 600;
                color: #ffffff;
                position: absolute;
                top: 50%;
                left: 0%;
                transform: translate(-14px, -50%);
              }
            }

            .bz_color {
              background: #fff3e7;
            }
            .bz_color2 {
              background: #ffe5cc;
            }
          }
          .cszg_title {
            min-width: 160px;
            height: 36px;
            background: #ff9003;
            box-shadow: 0px 0px 7px 0px rgba(249, 118, 47, 0.3);
            border-radius: 31px 31px 31px 31px;
            border: 2px solid #ffffff;
            padding: 7px 48px;
            box-sizing: border-box;
            font-size: 18px;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 600;
            color: #ffffff;
            margin: auto;
            margin-bottom: 16px;
          }

          .cszg_centent {
            width: 100%;
            font-size: 16px;
            font-family: PingFang SC-Semibold, PingFang SC;
            color: #666666;
            line-height: 24px;
            text-align: left;
            margin-bottom: 44px;

            span {
              color: #f97226;
              font-weight: 600;
            }
          }

          .cszg_centent:last-child {
            margin-bottom: 0px;
          }
          .bxxq_centent {
            width: 100%;
            margin-bottom: 44px;

            ul {
              width: 100%;
              padding-left: 0.48rem;
              box-sizing: border-box;

              li {
                width: 100%;
                font-size: 16px;
                font-family: PingFang SC-Semibold, PingFang SC;
                color: #666666;
                line-height: 28px;
                text-align: left;
                list-style: disc;

                span {
                  color: #f97226;
                  font-weight: 600;
                }

                font {
                  color: #e80202;
                  font-weight: 600;
                }
              }
            }

            .a_view {
              text-align: center;
              font-size: 16px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #e80202;
              text-decoration: underline;
              cursor: pointer;
            }
          }

          .bxxq_centent:last-child {
            margin-bottom: 0px;
          }
        }
      }

      .cszg2 {
        .cszg2_list {
          // font-size: 15px;
          // font-family: PingFang SC-Semibold, PingFang SC;
          // font-weight: 600;
          // // color: #f97226;
          // line-height: 22px;
          // text-align: left;
          margin-bottom: 24px;
          ul {
            width: 100%;
            padding-left: 0.48rem;
            box-sizing: border-box;

            li {
              width: 100%;
              font-size: 16px;
              font-family: PingFang SC-Semibold, PingFang SC;
              color: #666666;
              line-height: 28px;
              text-align: left;
              list-style: disc;
            }
          }
        }

        .cszg2_uls {
          width: 100%;
          padding-left: 12px;
          box-sizing: border-box;
          margin-bottom: 24px;

          .cszg2_uls_list {
            width: 100%;
            height: 48px;
            border-radius: 0px 0px 0px 0px;
            font-size: 15px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: 15px;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;

            .select_bz {
              min-width: 79px;
              background: #f97226;
              border-radius: 60px 60px 60px 60px;
              padding: 3px 18px;
              box-sizing: border-box;
              background: #f97226;
              border-radius: 60px 60px 60px 60px;
              font-size: 15px;
              font-family: PingFang SC-Semibold, PingFang SC;
              font-weight: 600;
              color: #ffffff;
              position: absolute;
              top: 50%;
              left: 0%;
              transform: translate(-14px, -50%);
            }
          }

          .bz_color {
            background: #fff3e7;
          }
          .bz_color2 {
            background: #ffe5cc;
          }
        }

        .cszg2_remarks {
          width: 100%;
          font-size: 15px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 22px;
        }
      }

      .bxxq {
        width: 100%;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;

        .bxxq_title {
          min-width: 160px;
          height: 36px;
          background: #ff9003;
          box-shadow: 0px 0px 7px 0px rgba(249, 118, 47, 0.3);
          border-radius: 31px 31px 31px 31px;
          border: 2px solid #ffffff;
          padding: 7px 48px;
          box-sizing: border-box;
          font-size: 18px;
          font-family: PingFang SC-Semibold, PingFang SC;
          font-weight: 600;
          color: #ffffff;
          margin: auto;
          margin-bottom: 16px;
        }

        .bxxq_centent {
          width: 100%;
          margin-bottom: 44px;

          ul {
            width: 100%;
            padding-left: 0.48rem;
            box-sizing: border-box;

            li {
              width: 100%;
              font-size: 16px;
              font-family: PingFang SC-Semibold, PingFang SC;
              color: #666666;
              line-height: 28px;
              text-align: left;
              list-style: disc;

              span {
                color: #f97226;
                font-weight: 600;
              }

              font {
                color: #e80202;
                font-weight: 600;
              }
            }
          }

          .a_view {
            text-align: center;
            font-size: 16px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #e80202;
            text-decoration: underline;
            cursor: pointer;
          }
        }

        .bxxq_centent:last-child {
          margin-bottom: 0px;
        }
      }

      .csjx {
        width: 100%;
        display: flex;
        flex-wrap: wrap;

        .csjx_title {
          min-width: 160px;
          height: 36px;
          background: #ff9003;
          box-shadow: 0px 0px 7px 0px rgba(249, 118, 47, 0.3);
          border-radius: 31px 31px 31px 31px;
          border: 2px solid #ffffff;
          padding: 7px 48px;
          box-sizing: border-box;
          font-size: 16px;
          font-family: PingFang SC-Semibold, PingFang SC;
          font-weight: 600;
          color: #ffffff;
          margin: auto;
          margin-bottom: 24px;
        }

        // .csjx_centent:last-child {
        //   margin-bottom: 0px;
        // }

        .csjx_centent {
          width: 100%;
          margin-bottom: 44px;

          .csjx_centent_view1 {
            width: 414px;
            min-height: 141px;
            padding: 16px 24px;
            box-sizing: border-box;
            background: #fff6f1;
            border-radius: 16px;
            border: 2px solid #fed011;
            position: relative;
            margin: auto;
            margin-bottom: 24px;

            h1 {
              width: 100%;
              display: flex;
              font-size: 16px;
              font-family: PingFang SC-Semibold, PingFang SC;
              font-weight: 600;
              color: #f97226;
              line-height: 18px;

              span {
                color: #ff8f03;
                margin-left: 8px;
                font-weight: 500;
                font-size: 14px;
              }
            }

            ul {
              width: 100%;
              margin-top: 20px;
              padding-left: 20px;
              box-sizing: border-box;

              li {
                width: 100%;
                font-size: 14px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
                line-height: 14px;
                text-align: left;
                list-style: disc;
                font-weight: 400;
                margin-bottom: 15px;
              }

              li:last-child {
                margin-bottom: 0px;
              }
            }

            .jinpai {
              width: 90px;
              position: absolute;
              right: -37px;
              bottom: -6px;

              img {
                width: 100%;
              }
            }

            .jiangbei {
              width: 90px;
              position: absolute;
              right: -40px;
              bottom: -6px;

              img {
                width: 100%;
              }
            }
          }

          .csjx_centent_view2 {
            width: 414px;
            background: #fff6f1;
            border-radius: 16px;
            border: 1px solid #fa772f;
            position: relative;
            margin: auto;
            // margin-bottom: 24px;
            display: flex;

            .lists {
              width: 146px;
              height: 98px;
              font-size: 14px;
              font-family: PingFang SC-Semibold, PingFang SC;
              color: #f97226;
              line-height: 20px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-right: 1px solid #fa772f;
            }

            .lists2 {
              width: calc(100% - 146px);

              ul {
                width: 100%;
                height: 100%;
                padding: 16px 24px 16px 48px;
                box-sizing: border-box;
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                align-content: center;

                li {
                  width: 100%;
                  font-size: 14px;
                  font-family: PingFang SC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #666666;
                  text-align: left;
                  list-style: disc;
                  font-weight: 400;
                  margin-bottom: 16px;
                }

                li:last-child {
                  margin-bottom: 0px;
                }
              }
            }
          }

          .bo_color {
            background: #fffce8 !important;
            border: 2px solid #fed011 !important;
          }

          .bo_color2 {
            background: #f9fcff !important;
            border: 2px solid #d1e1ee !important;
          }
          .bo_color3 {
            background: #fff4ee !important;
            border: 2px solid #fa772f !important;
          }
        }
      }
    }
  }
  .uploadVideo {
    cursor: pointer;
    position: absolute;
    z-index: 999999;
    top: 16px;
    right: 150px;
    width: 136px;
    height: 48px;
    background: url("~@/assets/image/icon/but.png") no-repeat;
    background-size: 100% 100%;
    font-size: 20px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    line-height: 15px;
    box-shadow: 0px 4px 9px 0px rgba(244, 86, 5, 0.4);
    border-radius: 80px;
    padding: 15px;
    box-sizing: border-box;
  }

  .datumBox {
    width: 780px;
    padding-top: 45px;
    padding-bottom: 45px;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 16px 16px 16px 16px;

    .titleH1 {
      width: 100%;
      font-size: 22px;
      color: #ff5a25;
      font-weight: 600;
      border-radius: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 20px;

      .right_icon {
        display: flex;
        align-items: center;
        div:nth-child(3) {
          display: inline-block;
          width: 6px;
          height: 6px;
          border-radius: 3px;
          background-color: #ff5a25;
          margin-left: 7px;
        }
        div:nth-child(2) {
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 4px;
          background-color: #ff5a25;
          margin-left: 7px;
        }
        div:first-child {
          display: inline-block;
          width: 10px;
          height: 10px;
          border-radius: 5px;
          background-color: #ff5a25;
          margin-left: 7px;
        }
      }

      .left_icon {
        display: flex;
        align-items: center;
        div:first-child {
          display: inline-block;
          width: 6px;
          height: 6px;
          border-radius: 3px;
          background-color: #ff5a25;
          margin-right: 7px;
        }
        div:nth-child(2) {
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 4px;
          background-color: #ff5a25;
          margin-right: 7px;
        }
        div:nth-child(3) {
          display: inline-block;
          width: 10px;
          height: 10px;
          border-radius: 5px;
          background-color: #ff5a25;
          margin-right: 7px;
        }
      }
    }

    .stepBox {
      width: 80%;
      margin: auto;
      position: relative;

      .stepUls {
        width: 100%;
        height: 30px;
        display: flex;

        .xian {
          width: 50%;
          height: 100%;
          position: relative;
        }

        .active {
          position: relative;
        }

        .active:after {
          content: " ";
          width: 100%;
          height: 2.5px;
          background: #f5f5f5;
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          margin: auto;
        }

        .active2:after {
          content: " ";
          width: 100%;
          height: 2.5px;
          background: #ff5a25;
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          margin: auto;
        }
      }

      ul {
        width: 100%;
        height: 30px;
        position: absolute;
        left: 0;
        top: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;

        li {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background-color: #ff5a25;
          position: relative;

          div {
            position: absolute;
            bottom: -10%;
            font-size: 12px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #cccccc;
          }
        }

        .active {
          width: 19px;
          height: 19px;
          border-radius: 50%;
          background: url("~@/assets/image/fusai/dui.png") no-repeat;
          background-size: 100%;
        }
      }
    }

    .stepText {
      width: 80%;
      margin: auto;
      height: 30px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      div {
        width: 33%;
        font-size: 18px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #cccccc;
      }
      div:nth-child(1) {
        text-align: left;
      }
      div:nth-child(2) {
        text-align: center;
      }
      div:nth-child(3) {
        text-align: right;
      }

      .active {
        color: #de2810 !important;
      }
    }

    .datumCentent {
      width: 70%;
      margin: auto;
      margin-top: 30px;

      .tab {
        width: 100%;
        text-align: left;
        margin-bottom: 13px;

        .prompt {
          font-size: 16px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #4d4d4d;
          margin-bottom: 12px;

          div {
            margin-right: 18px;
            text-align: center;
            line-height: 20px;
            color: #999999;
          }

          .highlight {
            color: #4d4d4d !important;
            position: relative;
          }

          .highlight:after {
            content: " ";
            width: 90%;
            height: 1px;
            background: #4d4d4d;
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            margin: auto;
          }

          span {
            font-size: 12px;
            color: #de2810;
            margin-left: 5px;
          }
        }

        .promptInput {
          width: 100%;
          height: 50px;
          display: flex;
          align-items: center;
          padding-left: 15px;
          box-sizing: border-box;
          background: #f5f5f5;
          border-radius: 5px;
          margin-bottom: 15px;

          .right-btn {
            padding: 0 20px;
            text-align: right;
            font-size: 12px;
            color: #de2810;
            cursor: pointer;
          }

          input {
            flex: 1;
            height: 100%;
            font-size: 13px;
            font-family: PingFang SC-Regular, PingFang SC;
            background: #f5f5f5;
            border-radius: 5px;
            border: none;
            box-sizing: border-box;
          }

          input::-webkit-input-placeholder {
            color: #999999;
          }
          /* 使用webkit内核的浏览器 */
          input:-moz-placeholder {
            color: #999999;
          }
          /* Firefox版本4-18 */
          input::-moz-placeholder {
            color: #999999;
          }
          /* Firefox版本19+ */
          input:-ms-input-placeholder {
            color: #999999;
          } /* IE浏览器 */
        }

        .promptInput2 {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 50px;
          line-height: 50px;
          box-sizing: border-box;
          background: #f5f5f5;
          border-radius: 5px;
          margin-bottom: 15px;

          span {
            width: 100%;
            height: 100%;
          }
          .span_tw {
            color: rgb(153, 153, 153) !important;
          }
          .promptInputValue {
            width: 100%;
            height: 100%;
            padding-left: 13px;
            box-sizing: border-box;
            border: none;
            background: #f5f5f5;
            border-radius: 6px 6px 6px 6px;
            font-size: 12px;
            font-family: PingFang SC-Regular, PingFang SC;
          }
        }

        .promptInput3 {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          background-color: #f7f8fa;
          height: 210px;
          position: relative;

          .wonderful {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 600;
            color: #4d4d4d;

            img {
              width: 40px;
              height: 40px;
              border-radius: 50px;
              margin-bottom: 30px;
            }
          }

          .videoYulan {
            width: 100%;
            height: 100%;
            z-index: 999999;
            position: fixed;
            top: 0;
            left: 0;
            background: rgba(0, 0, 0, 0.8);
            display: flex;
            align-items: center;
            justify-content: center;
            overflow: hidden;

            video {
              width: 80%;
              // object-fit: cover;
              height: 100%;
            }

            .guanbu {
              position: absolute;
              top: 5%;
              right: 5%;
              width: 20px;
              height: 20px;
              color: #fff;
              font-size: 12px;
              z-index: 999;
              border-radius: 10px;
              border: 1px solid #fff;
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }

          .videoYulan2 {
            // cursor: pointer;
            // color: #ff5a25;
            // margin-left: 10px;
            position: absolute;
            bottom: 8px;
            right: 0px;
            left: 0px;
            margin: auto;
            font-size: 12px;
            color: #ff5a25;
            text-align: center;
            width: 100%;
          }
        }

        .cell-item {
          margin-bottom: 15px;
          .tips {
            color: #de2810;
            font-size: 12px;
          }

          .promptInput {
            margin-bottom: 10px;
          }
        }
      }

      .tabTis {
        width: 100%;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 13px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #4d4d4d;
        margin-bottom: 50px;

        img {
          width: 20px;
          height: 20px;
          margin-left: 10px;
        }
      }

      .but {
        min-width: 150px;
        height: 40px;
        display: inline-block;
        padding: 5px 15px;
        background: url("~@/assets/image/but.png") no-repeat;
        background-size: 100% 100%;
        text-align: center;
        line-height: 40px;
        font-size: 14px;
        font-weight: bold;
        color: #fff;
        margin: auto;
        margin-top: 20px;
      }

      .but2 {
        width: 140px;
        height: 30px;
        text-align: center;
        font-size: 14px;
        color: #4d4d4d;
        margin: auto;
        margin-top: 10px;
      }
    }
  }
}

::v-deep .CountryCodeSelectorContainer {
  width: 100px;
  .arrow-down {
    width: 12px;
    height: 12px;
  }
}
.viewVideo {
  position: absolute;
  bottom: 30px;
  font-size: 12px;
  color: #4d4d4d;
  text-align: center;
  width: 100%;
  display: flex;
  justify-content: center;
}
.reselect {
  position: absolute;
  bottom: 5px;
  font-size: 12px;
  margin: 0 auto;
  color: rgb(235, 196, 120);
  cursor: pointer;
}
.newShortBox {
  width: 600px;
  height: 308px;
  padding-top: 24px;
  padding-bottom: 24px;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 16px 16px 16px 16px;

  .list {
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;

    .lis {
      width: 100%;
      margin-bottom: 20px;
    }

    .lis:last-child {
      margin-bottom: 0px !important;
    }

    .lisCenten {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .lisText2 {
      display: flex;
      justify-content: space-between;
      width: 65%;
      margin: auto;
      font-size: 14px;

      span {
        color: #ff5a25;
      }
    }

    .ulst {
      width: 70%;
      margin: auto;

      ul {
        display: flex;
        justify-content: space-between;
        width: 100%;
        border-radius: 3px 3px 3px 3px;

        li {
          width: 33.3%;
          text-align: center;
          font-size: 14px;
          padding: 0 5px;
        }
        li:nth-child(2) {
          width: 30% !important;
        }
      }

      ul:nth-child(1) {
        background: #ff5a25;
        height: 30px;
        line-height: 30px;

        li {
          height: 100%;
          color: #fff;
        }
      }

      ul:nth-child(2) {
        background: #feffeb;
        font-size: 9.8px !important;
        line-height: 20px;
        margin-top: 10px;
        margin-bottom: 20px;

        li {
          color: #4e4e4e;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }

    .lisText {
      font-size: 15px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e4e4e;
      line-height: 24px;
    }

    .but {
      width: 140px;
      height: 40px;
      background: url("~@/assets/image/but.png") no-repeat;
      background-size: 100%;
      text-align: center;
      line-height: 36px;
      font-size: 14px;
      font-weight: bold;
      color: #fff;
      margin: auto;
    }
  }
}
.show-link {
  color: #f97226;
  font-weight: 400 !important;
}
.show-link:hover {
  font-weight: 600 !important;
  text-decoration: underline;
  cursor: pointer;
}

.guide-container {
  padding: 16px;
  min-height: 600px;
  overflow-y: auto;
}

.bag_text {
  font-size: 16px;
  font-family: PingFang SC-Semibold, PingFang SC;
  color: #666666;
  line-height: 28px;
  text-align: left;
  background-color: #fff3e7;
  // background-color: #ffe5cc;
  padding: 8px 12px;
  border-radius: 6px;
  margin-bottom: 8px;
}
.contest_content {
  font-size: 16px;
  font-family: PingFang SC-Semibold, PingFang SC;
  color: #f97226;
  margin: 10px 0 20px 0;
  text-align: left;
  line-height: 20px;
  // font-weight: 600;
}
.font_red {
  color: #ff5a25;
  font-weight: 600;
}
.tables {
  position: relative;
  width: 100%;
  background-color: #fff;
  border-radius: 12px;
  padding: 24px;
  box-sizing: border-box;
  table {
    width: 100%;
    margin: 0 auto;
    border-collapse: separate;
    border-spacing: 0px;
    border: 1px solid #fa772f;
    font-size: 16px;
    line-height: 22px;
    font-family: PingFang SC-Semibold, PingFang SC;
    color: #666666;
    th {
      border: 1px solid #fa772f;
      padding: 10px;
      font-weight: 600;
    }
    td {
      border: 1px solid #fa772f;
      padding: 10px;
      vertical-align: middle;
    }
    span {
      // color: #e80202;
      font-weight: 600;
    }
  }
}
</style>
